export const enum ModalBlockSlug {
  HEADER = 'header',
  BUTTON = 'button',
  OFFER_DETAILS = 'offer-details',
  LEGAL_TERMS = 'legal-terms',
}

export const enum BlockType {
  CLOSE_HANDLER = 'close-handler',
  OPEN_HANDLER = 'open-handler',
  ADDITIONAL_LOGIC = 'additional-logic',
  DEFAULT = 'default',
  DYNAMIC = 'dynamic',
}
